import '@/assets/js/google-tag-metrics';
import '@/assets/js/widget-replain-scripts';
import { initYandexMetrika } from './yandex-metric-loader';
import config from '@/config';

let isInitialized = false;

export const initMetrics = (lang) => {
    if (isInitialized) {
        console.warn('Метрики уже инициализированы');
        return;
    }

    const counters = {
        en: 93847903,
        ru: 98352873,
    };

    const counterId = counters[lang];

    if (!counterId) {
        console.warn('Не найден счетчик для языка:', lang);
        return;
    }

    console.log('Инициализация Яндекс.Метрики с ID:', counterId);
    initYandexMetrika(counterId);
    isInitialized = true;
};
